<template>
  <div class="gradeDetail">
    <van-nav-bar class="page_nav" :class="{bg:examList.length>0}" :title="$route.query.certName" left-arrow @click-left="onClickLeft" :fixed="true" />
    <div class="placeholder_box" :class="{bg:examList.length>0}" style="height:46PX;"></div>
    <div class="main_content" v-if="examList && examList.length">
      <div v-for="(examItem,index) in examList" :key="index">
          <div class="examPlan_grade" v-if="!examItem.isReadScore || examItem.isLack  || examItem.isReadScore && examItem.userPaperRecordDtos && examItem.userPaperRecordDtos.length" >
            <div class="title">
              <img class="ks_icon" src="./assets/images/ic-zytm.png"/>
              <span class="text">{{examItem.name}}</span>
            </div>
            <div class="noContent ex_item" v-if="!examItem.isReadScore">
                <img src="./assets/images/no_grade.png"/>
                <p class="trainging-noContent">成绩未公布哟～</p>
            </div>
            <div class="noContent ex_item" v-else-if="examItem.isLack">
                <img src="./assets/images/quekao.png"/>
                <p class="trainging-noContent">本次考试缺考了呦～</p>
            </div>
            <template v-else-if="examItem.isReadScore && examItem.userPaperRecordDtos && examItem.userPaperRecordDtos.length">
              <div class="ex_item" v-for="(item,index2) in examItem.userPaperRecordDtos" :key="index2">
                  <p class="c_item">
                    <span class="s_title">参考时间：</span>
                    <span class="s_text">{{item.enterTime}}</span>
                  </p>
                  <p class="c_item">
                    <span class="s_title">考试成绩：</span>
                    <span class="s_title">{{item.isReadOver ==1?item.score+'分':'批阅中'}}</span>
                  </p>
              </div>
            </template>
          </div>
      </div>
    </div>
    <div class="noData" v-if="!examList.length">
        <p class="txt">暂无数据~</p>
    </div>

   
    
  </div>
</template>

<script>
export default {
  name: "gradeDetail",
  data() {
    return {
      examList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getData() {
      this.$api.rensheDistributionExam
        .findScoreByPlanId({ ucode: this.$route.query.ucode })
        .then(res => {
          if (res.success) {
            this.examList = res.data || [];
            //过滤数据
           this.examList = this.examList.filter((examItem)=>{
                return !(examItem.isReadScore && !examItem.isLack && examItem.userPaperRecordDtos && examItem.userPaperRecordDtos.length==0)
            })
          }
        });
    }
  }
};
</script>

<style scoped lang="stylus">
.gradeDetail {
  min-height: 100vh;
  background: #F8F9FA;
  padding-bottom: 40px;
  box-sizing: border-box;

  .van-hairline--bottom:after {
    border: 0 !important;
  }

  .noContent {
    text-align: center;
    padding-top: 8px;
    padding-bottom: 8px;

    // padding-top: 26%;
    img {
      // width: 484px;
      // height: 300px;
      width: 400px;
      // height:150px;
    }

    .trainging-noContent {
      color: #999999;
      font-size: 28px;
      font-weight: 400;
      margin-top: 16px;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }

  .noData {
    text-align: center;
    padding-top: 26%;
    .txt{
      color: #999999;
      font-size: 28px;
      font-weight: 400;
      margin-top: 16px;
      line-height: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}

.placeholder_box.bg {
  background-color: #416DF6;
}

.page_nav {
  position: fixed;

  &.bg {
    background-color: #416DF6;

    /deep/ .van-nav-bar__content {
      .van-icon.van-icon-arrow-left, .van-nav-bar__title {
        color: #fff;
      }
    }
  }
}

.main_content {
  padding-top: 20px;
  background-image: url('./assets/images/grade_topbg.png');
  background-repeat: no-repeat;
  background-size: 100% 242px;
  background-position-y: -2px;
}

.examPlan_grade {
  width: 690px;
  // height: 568px;
  background: #FFFFFF;
  box-shadow: 0px 8px 32px 0px rgba(133, 153, 194, 0.08);
  border-radius: 16px;
  padding: 40px 24px 24px;
  box-sizing: border-box;
  margin: 0 auto 16px;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 42px;

    .ks_icon {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    .text {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202124;
      line-height: 42px;
    }
  }

  .ex_item {
    width: 100%;
    min-height: 130px;
    background: #F7F7F7;
    border-radius: 8px;
    margin: 16px auto 0;
    padding: 24px;
    box-sizing: border-box;

    .c_item {
      font-size: 26px;
      line-height: 37px;

      .s_title {
        color: #767687;
      }

      .s_text {
        color: #202124;
      }

      &:not(:first-child) {
        margin-top: 11px;
      }
    }
  }
}
</style>
